import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  listMemberFeatureOverrides,
  listRoleFeatureAccess,
  updateMemberFeatureOverride,
  updateRoleFeatureAccess,
} from '@/lib/access-control'

const ROLES_KEY = ['access-control', 'roles'] as const
const OVERRIDES_KEY = ['access-control', 'overrides'] as const

export function useRoleFeatureAccess() {
  return useQuery({ queryKey: ROLES_KEY, queryFn: listRoleFeatureAccess })
}

export function useUpdateRoleFeatureAccess() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: updateRoleFeatureAccess,
    onSuccess: () => qc.invalidateQueries({ queryKey: ROLES_KEY }),
  })
}

export function useMemberFeatureOverrides() {
  return useQuery({ queryKey: OVERRIDES_KEY, queryFn: listMemberFeatureOverrides })
}

export function useUpdateMemberFeatureOverride() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: updateMemberFeatureOverride,
    onSuccess: () => qc.invalidateQueries({ queryKey: OVERRIDES_KEY }),
  })
}
